export const ActivitiesCallCenterPermissions = {
  AddNewActivity: {
    permissionsId: 'a5e7c604-541a-48e2-8688-08d93098df4e',
    permissionsName: 'Add new activity',
    componentsId: null,
    components: null,
  },
  ViewAndSearchInCallCenterActivities: {
    permissionsId: '05874280-2f03-4faf-8689-08d93098df4e',
    permissionsName: 'View and search in Call Center Activities',
    componentsId: null,
    components: null,
  },
  ViewActivityDetails: {
    permissionsId: '443d6293-d6f7-4f23-868a-08d93098df4e',
    permissionsName: 'View Activity details',
    componentsId: null,
    components: null,
  },
  EditActivity: {
    permissionsId: 'ee24459d-b2b9-4e48-868b-08d93098df4e',
    permissionsName: 'Edit Activity ',
    componentsId: null,
    components: null,
  },
};
